import { OnboardingRouteRedirect } from '../../components';

export default function Step7GoalsRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-7-life-events" />;
}
